import { FC } from "react";
import ForgotSuccessForm from "../../components/Form/ForgotSuccess";

const ForgotSuccessPage: FC = () => {
  return <ForgotSuccessForm />;
};

export default ForgotSuccessPage;
